import { AnimatePresence } from 'framer-motion';
import { useRetainHistoryContext } from '../../../contexts/RetainHistoryProvider';
import { RetainAgreement } from '../../../types/retain';
import RetainAgreementDetailsModal from '../../CommonComps/Modals/RetainAgreementDetailsModal';

const RetainHistoryModalsContainer = () => {
  // integration of context hooks here
  const { selectedRetainHistory, showDetailsModal, setShowDetailsModal } =
    useRetainHistoryContext();

  // rendering retain history modals container component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showDetailsModal && (
          <RetainAgreementDetailsModal
            title='Retain History'
            retainHistory={selectedRetainHistory as RetainAgreement}
            handleModalClose={() => setShowDetailsModal(false)}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default RetainHistoryModalsContainer;
